/* montreveUS · collection + search: live filters, sort, active chips, filter drawer.
   Everything works without JS as a plain GET form and normal page links. */
(() => {
  const wt = window.wt;
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  class WtCollection extends HTMLElement {
    connectedCallback() {
      this.form = $('[data-facets-form]', this);
      this.panel = $('[data-facets-panel]', this);
      if (this.form) {
        let timer;
        this.form.addEventListener('change', (e) => {
          clearTimeout(timer);
          timer = setTimeout(() => this.apply(this.formUrl()), e.target.type === 'number' ? 600 : 50);
        });
        this.form.addEventListener('submit', (e) => {
          e.preventDefault();
          this.apply(this.formUrl());
          this.closePanel();
        });
      }
      this.addEventListener('click', (e) => {
        const link = e.target.closest('[data-facet-link], [data-facets-clear]');
        if (link) { e.preventDefault(); this.apply(link.href); return; }
        if (e.target.closest('[data-facets-open]')) { this.openPanel(); return; }
        if (e.target.closest('[data-facets-close]')) this.closePanel();
      });
      this.addEventListener('keydown', (e) => { if (e.key === 'Escape' && this.panel && this.panel.classList.contains('is-open')) this.closePanel(); });
      window.addEventListener('popstate', () => this.apply(window.location.href, false));
    }

    formUrl() {
      const params = new URLSearchParams();
      for (const [key, value] of new FormData(this.form)) if (String(value).trim() !== '') params.append(key, value);
      const base = new URL(this.form.action, window.location.origin);
      return `${base.pathname}?${params}`;
    }

    async fetchSection(url) {
      const u = new URL(url, window.location.origin);
      u.searchParams.set('section_id', this.dataset.section);
      const res = await fetch(u);
      return new DOMParser().parseFromString(await res.text(), 'text/html');
    }

    async apply(url, push = true) {
      this.classList.add('is-loading');
      try {
        const doc = await this.fetchSection(url);
        ['[data-count]', '[data-active-filters]', '[data-results-wrap]', '[data-facets-open]', '[data-tag-filters]'].forEach((sel) => {
          const fresh = $(sel, doc);
          const current = $(sel, this);
          if (fresh && current) current.innerHTML = fresh.innerHTML;
        });
        $$('[data-facet]', doc).forEach((fresh) => {
          const current = $(`[data-facet="${fresh.dataset.facet}"]`, this);
          if (current) current.innerHTML = fresh.innerHTML;
        });
        const freshForm = $('[data-facets-form]', doc);
        if (freshForm && this.form) this.form.setAttribute('action', freshForm.getAttribute('action'));
        const sort = $('[data-facets-sort]', doc);
        const curSort = $('[data-facets-sort]', this);
        if (sort && curSort) curSort.value = sort.value;
        if (push) window.history.pushState({}, '', url);
      } catch (err) {
        window.location.href = url;
      } finally {
        this.classList.remove('is-loading');
      }
    }

    openPanel() {
      if (!this.panel) return;
      this.trigger = document.activeElement;
      this.panel.classList.add('is-open');
      $('[data-overlay]').hidden = false;
      document.documentElement.classList.add('wt-locked');
      $$('[data-facets-open]', this).forEach((b) => b.setAttribute('aria-expanded', 'true'));
      const close = $('[data-facets-close]', this.panel);
      if (close) close.focus();
      this.overlayHandler = () => this.closePanel();
      $('[data-overlay]').addEventListener('click', this.overlayHandler, { once: true });
    }

    closePanel() {
      if (!this.panel || !this.panel.classList.contains('is-open')) return;
      this.panel.classList.remove('is-open');
      $('[data-overlay]').hidden = true;
      document.documentElement.classList.remove('wt-locked');
      $$('[data-facets-open]', this).forEach((b) => b.setAttribute('aria-expanded', 'false'));
      if (this.trigger) this.trigger.focus();
    }
  }
  customElements.define('wt-collection', WtCollection);
})();
